import React, { useState, useEffect } from 'react'
import exporticon from "../../../assets/image/Excel_Download_Icon.png";
import { getApi } from '../../../utils/services';
import { BILLS_API, STATUS_LIST } from '../../../utils/apiRoutes';
import { Link } from 'react-router-dom';
import moment from "moment";
import Select from "react-select";
import Loader from '../../common/Loader';
import { useTransactionContext } from '../../../utils/helpers/useTransaction';
import { handleList } from '../../../utils/helpers/globalMethod';
import { VOID_STATUS_ID } from '../../../utils/constant';

const IndividualBillReport = () => {

  const monthStartDate = moment().startOf('month');
  const monthEndDate = moment().endOf('month');

  const transactionList = useTransactionContext();
  const [fromDate, setFromDate] = useState(monthStartDate.format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(monthEndDate.format('YYYY-MM-DD'));
  const [statusList, setStatusList] = useState([])
  const [statusId, setStatusId] = useState('');
  const [paymentId, setPaymentId] = useState('');
  const [vendorList, setVendorList] = useState([]);
  const [vendorName, setVendorName] = useState('');
  const [individualBillReportList, setIndividualBillReportList] = useState([])
  const [loader, setLoader] = useState(false);
  const [totalTds, setTotalTds] = useState()
  const [grandTotal, setGrandTotal] = useState();
  const [currencySymbol, setCurrencySymbol] = useState('');

  useEffect(() => {
    const fetchList = async () => {
      await handleList(setVendorList);
    };

    fetchList();
  }, []);

  const handleStatusData = async () => {
    const result = await getApi(`${STATUS_LIST}?transactionId=${transactionList[1].id}`);
    setStatusList(result.res.status_list);
  };

  useEffect(() => {
    handleStatusData();
  }, []);

  useEffect(() => {
    const handleIndividualBillReport = async () => {
      setLoader(true)
      const result = await getApi(`${BILLS_API}?billType=1&startDate=${fromDate}&endDate=${toDate}&type='report'`)
      const updatedResult = result.res.bill_list.filter((i) => i.BillStatusId !== VOID_STATUS_ID)
      setLoader(false)
      setIndividualBillReportList({ ...result.res, bill_list: updatedResult })
      const totalGrandAmount = updatedResult.reduce((total, obj) => total + obj.Total, 0);
      setGrandTotal(totalGrandAmount)
      const totalTdsAmount = updatedResult.reduce((total, obj) => total + obj.TDSAmount, 0);
      setTotalTds(totalTdsAmount);
      setCurrencySymbol(updatedResult?.find(item => item.SubsidiaryId === 2)?.CurrencySymbol);
    }
    handleIndividualBillReport()
  }, [])

  const handleExportData = () => {
    const csvData = [
      ['Bill Number', 'Payment ID', 'Vendor Name', 'Created Date', 'Grand Total', 'TDS Amount', 'Status'],
      ...individualBillReportList.bill_list.map(person => [person.DocumentNo, person.UserPaymentId ? person.UserPaymentId : "N/A", person.LegalName, moment(person.CreatedAt).format('D/MM/YYYY')?.slice(0, 10), person.Total, person.TDSAmount, person.StatusName]),
      [], ["", "", "", "Total:", grandTotal, totalTds, ""]
    ];
    const csvContent = csvData.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Bill.csv';
    link.click();
    URL.revokeObjectURL(url);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true)
    const result = await getApi(`${BILLS_API}?billType=1&startDate=${fromDate}&endDate=${toDate}&paymentId=${paymentId}&status=${statusId}&vendorName=${vendorName}&type='report'`)
    const updatedResult = result.res.bill_list.filter((i) => i.BillStatusId !== VOID_STATUS_ID)
    setLoader(false)
    setIndividualBillReportList({ ...result.res, bill_list: updatedResult })
    const totalTdsAmount = updatedResult.reduce((total, obj) => total + obj.TDSAmount, 0);
    setTotalTds(totalTdsAmount);
    const totalGrandAmount = updatedResult.reduce((total, obj) => total + obj.Total, 0);
    setGrandTotal(totalGrandAmount)
    const currency = updatedResult?.find(item => item.SubsidiaryId === 2)?.CurrencySymbol;
    setCurrencySymbol(currency);
  };

  const options = [
    { value: '', label: 'Select Vendor' },
    ...vendorList.map((item) => ({
      value: item.LegalName,
      label: item.LegalName,
    })),
  ];

  return (
    <form>
      <div className="form-style">
        <div className="report-inpfiled-container">

          <div className="field-flex mb-20">
            <label htmlFor="vendorName" className="form-label">
              Vendor Name
            </label>
            <Select
              id="vendorName"
              className=""
              name="vendorName"
              value={vendorList.find((item) => item.id === vendorName)}
              onChange={(item) => setVendorName(item?.value || "")}
              options={options}
              isClearable={vendorName}
            />
          </div>

          <div className="field-flex mb-20">
            <label htmlFor="transactionStatus" className="form-label">
              Transaction Status
            </label>

            <select
              id="transactionStatus"
              className="form-select"
              name="transactionStatus"
              value={statusId}
              onChange={(e) => setStatusId(e.target.value)}
            >
              <option value="">Select </option>
              {statusList.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.Name}
                </option>
              ))}
            </select>
          </div>

          <div className="field-flex mb-20">
            <label htmlFor="paymentId" className="form-label">
              Payment Id
            </label>

            <input type="text" className="form-control" id="paymentId" placeholder="Enter payment Id" value={paymentId} onChange={(e) => setPaymentId(e.target.value)} />
          </div>

          <div className="field-flex mb-20">
            <label htmlFor="fromDate" className="form-label">
              From Date
            </label>
            <input
              type="date"
              id="fromDate"
              className="form-control"
              name="fromDate"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              onKeyDown={(e) => e.preventDefault()}
            ></input>
          </div>

          <div className="field-flex mb-20">
            <label htmlFor="toDate" className="form-label">
              To Date
            </label>

            <input
              type="date"
              id="toDate"
              className="form-control"
              name="toDate"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              onKeyDown={(e) => e.preventDefault()}
            />
          </div>

          <div className="field-flex align-self-end mb-20">
            <div className="success-btn ">
              <button type="submit" className="btn" onClick={handleSubmit}>
                Search
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr className='m-0' />

      <Loader isLoading={loader} />
      <>
        {
          individualBillReportList.record_count === 0 ?
            <div className="form-style">
              <div className='section-sub-heading'>
                <h3 className="text-center">{individualBillReportList.message}</h3>
              </div>
            </div>
            :
            <div className="form-style pb-4">
              <div className='d-flex align-items-center justify-content-between'>
                <div className='section-sub-heading'>
                  <h3>Standalone Bill</h3>
                </div>
                <div className='Export-Icon' onClick={handleExportData}>
                  <img src={exporticon} alt="" className='cursor-pointer' />
                </div>
              </div>
              <div className='table-responsive tbl-body-shadow'>
                <table className="w-100 table-theme-1">
                  <thead>
                    <tr>
                      <th className="text-right">Bill Number</th>
                      <th className="text-left">Payment ID</th>
                      <th className="text-left">Vendor Name</th>
                      <th className="text-center">Created Date</th>
                      <th className="text-end">Grand Total</th>
                      <th className="text-end">TDS Amount</th>
                      <th className="text-left">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {individualBillReportList.bill_list?.map((row, index) => (
                      <tr key={index}>
                        <td className="text-right"> <Link className="" to={`/view-individual-bill/${row.id}`} target="_blank" >{row.DocumentNo}</Link></td>
                        <td className="text-left">{row?.PaymentId ? row?.PaymentId : "N/A"}</td>
                        <td className="text-left">{row?.LegalName}</td>
                        <td className="text-center">{moment(row?.CreatedAt).format('D/MM/YYYY')?.slice(0, 10)}</td>
                        <td className="text-end">{row?.CurrencySymbol} {row?.Total?.toFixed(2)}</td>
                        <td className="text-end">{row?.CurrencySymbol} {row?.TDSAmount?.toFixed(2)}</td>
                        <td className="text-left">{row?.StatusName}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="total-show">
                      <td className="text-end text-dark table-footer fw-bold"></td>
                      <td className="text-end text-dark table-footer fw-bold"></td>
                      <td className="text-end text-dark table-footer fw-bold"></td>
                      <td className="text-left text-dark text-center fw-bold">Total</td>
                      <td className="text-end text-dark fw-bold">{currencySymbol} {grandTotal && grandTotal?.toFixed(2)}</td>
                      <td className="text-end text-dark fw-bold">{currencySymbol} {totalTds && totalTds?.toFixed(2)}</td>
                      <td className="text-end text-dark fw-bold"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
        }
      </>

    </form>
  )
}

export default IndividualBillReport;